/* eslint-disable no-debugger */
import React, { useContext, useEffect, useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
// import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { BackTop, Col, Row, Typography, Form } from 'antd';
import styled from 'styled-components';
import { Button, Empty, Heading, Layout, Section } from 'components';
import { withRouter } from 'react-router';
import { Formik } from 'formik';
import TextLoop from 'react-text-loop';
import ReactPlayer from 'react-player/file';
import Carousel from '@brainhubeu/react-carousel';
import { useDispatch, useSelector } from 'react-redux';
import { t, Trans } from '@lingui/macro';
import { withI18n } from '@lingui/react';
import { useMutation, useQuery, withApollo } from 'react-apollo';
import { baseStyles } from 'styles/base';
import { booksAtHome, bumperAtHome, media, mobile, newClient } from 'helpers';
import orangeEl from 'assets/images/ellipse-orange.png';
import purpleEl from 'assets/images/ellipse-purple.png';
import homepageHero from 'assets/images/homepage.svg';
import TextInput from 'components/forms/TextInput';
import { QUERY_INTRO_VIDEO_HOME } from 'queries/profile';
import { GET_BOOSTED_CONTENT } from 'queries/content'
import { GET_BOOSTED_ARTICLES } from 'queries/articles'
import { queryFetchSubjects } from 'queries/data';
import { country, SocketContext } from 'App';
import { countryMap } from 'helpers/countryMapping';
import TutorCard from './TutorCard';
import ContentCard from './ContentCard';
import ArticleCard from './ArticleCard';
import IntroBlock from './IntroBlock';
import { fetchConsultants } from 'store/actions/contentfulActions';
import { useTutors } from 'helpers/hooks/data';
import DynamicIcon from 'components/common/DynamicIcon';
import { GENDER, SERVER_BASE_URL } from 'helpers/constants';
import HorizontalRow from 'components/HorizontalRow';
import useHotKey from 'helpers/hooks/useHotKey';
import { authUsersGetStories, generalPeopleGetStories, makeStoryAsRead } from '../../queries/stories';
import Stories from '../../components/Stories/Stories';
import { client } from '../../helpers';
import VisibilitySensor from 'react-visibility-sensor';
import { Content } from '@candulabs/react-sdk';

const programmeClient = newClient('programme');
const profileClient = newClient();

const { Paragraph } = Typography;

const sequence = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'x', 'x', 'x', 'Enter'];

function Home({ history, i18n, language }) {
	const { socket } = useContext(SocketContext);
	const dispatch = useDispatch();
	const currentCountry = countryMap[country];
	const consultants = useSelector(({ contentful }) => contentful.consultants);
	const [stories, setStroies] = useState([]);
	const userDetails = JSON.parse(localStorage.getItem('userDetails')) || {};
	const [content, setContent] = useState([]);
	const [articles, setArticles] = useState([]);

	useHotKey(sequence, () => console.log('ANDHAN KIMAAAAAAAKKKK!!!'));

	useQuery(queryFetchSubjects, {
		client: programmeClient,
		variables: { country },
		onCompleted: data => {
			data = data.getProgrammeSubjectList || [];
			const options = data.map(({ name, pvid }) => ({ value: Number(pvid), label: name }));
			setSubjectOptions(options);
		},
		onError: () => {
		}
	});

	useQuery(QUERY_INTRO_VIDEO_HOME, {
		client: profileClient,
		variables: { country, limit: 16 },
		onCompleted: data => {
			data = data.introVideoHome || [];
			setIntroVideoHome(data);
		},
		onError: () => {
		}
	});

	useQuery(generalPeopleGetStories, {
		client: client.storiesClient,
		variables: { country },
		fetchPolicy: 'network-only',
		onCompleted: ({ generalGetStories }) => {
			if (!userDetails.pvid) {
				setStroies([...generalGetStories]);
			}
		},
		onError: () => {
		}
	});

	useQuery(authUsersGetStories, {
		client: client.storiesClient,
		fetchPolicy: 'network-only',
		variables: { country },
		onCompleted: ({ getStories }) => {
			setStroies([...getStories]);
		},
		onError: () => {
		}
	});

	const [storySeen] = useMutation(makeStoryAsRead, {
		client: client.storiesClient
	});

	const [getHomePageBoostedContent] = useMutation(GET_BOOSTED_CONTENT, {
		client: newClient('content'),
		onCompleted: data => {
			if (data) {
				setContent(data.getHomePageBoostedContent);
			}
		},
		onError: err => {
		}
	});

	const [getBoostedArticlesOnHomePage] = useMutation(GET_BOOSTED_ARTICLES, {
		client: newClient('tutor_article'),
		onCompleted: data => {
			if (data) {
				setArticles(data.getBoostedArticlesOnHomePage);
			}
		},
		onError: err => {
		}
	});

	const [selectedSubject, setSelectedSubject] = useState({ value: -1, label: '' });
	const [keywords, setKeywords] = useState('');
	const [introVideoHome, setIntroVideoHome] = useState([]);
	const [subjectOptions, setSubjectOptions] = useState([]);
	const [selectedIntroVideo, setSelectedIntroVideo] = useState({});
	const [
		findTutors,
		{
			data: { tutors }
		}
	] = useTutors();

	const handleSearch = values => {
		setKeywords(values.keywords);
		history.push(`/${country}/browse/tutors?keywords=${values.keywords}`);
	};

	const handleSearchBySubject = selected => {
		setSelectedSubject({ value: selected.value, label: selected.label });
		history.push(`/${country}/browse/tutors?subjects=${selected.value}&subjectLabel=${selected.label}`);
	};

	const handleClickTutor = tutor => {
		window.open(`/${country}/${tutor.token}--${tutor.pvid}--${tutor.firstName}--${tutor.lastName}`);
	};

	const handleClickContent = content => {
		window.open(`/${country}/content/${content.pvid}--${content.title}`);
	};

	const handleClickArticle = article => {
		window.open(`/${country}/reads/details/${article.title.replace(/\?/g, "")}--${article.pvid}--${article.userPvid}`);
	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		// socket.on("FEEDS", (item) => {
		// 	console.log({ FEEDS: item })
		// })

		findTutors();
		getHomePageBoostedContent();
		getBoostedArticlesOnHomePage();

		dispatch(fetchConsultants());
	}, [dispatch, findTutors, socket, getHomePageBoostedContent, getBoostedArticlesOnHomePage]);

	return (
		<Layout breadcrumb={false} language={language}>
			<BackTop />
			<Row className="mb4em">
				<Col lg={24}>
					<Content slug="cudy-academics-homepage-banner" />
					{/* <HeroImage>
						<Col lg={10}>
							<Section>
								<BoldHeading
									content={
										<div>
											<Trans>
												We help students to prepare for examinations in{' '}
												<TextLoop interval={2000}>
													<span className="primary">Singapore</span>
													<span className="primary">Indonesia</span>
													<span className="primary">Malaysia</span>
													<span className="primary">India</span>
													<span className="primary">Vietnam</span>
													<span className="primary">Philippines</span>
													<span className="primary">Sri Lanka</span>
												</TextLoop>
											</Trans>
										</div>
									}
									subheader={<Trans>It's easy to find your best tutors on Cudy. Try it today!</Trans>}
									color="white"
								/>
								<Formik onSubmit={handleSearch} initialValues={{ keywords: '' }}>
									{({ handleSubmit }) => (
										<Form layout="vertical" onFinish={handleSubmit}>
											<TextInput
												name="keywords"
												placeholder={i18n._(t`Start by searching for subjects, e.g. English`)}
												width="100%"
												size="large"
											/>
										</Form>
									)}
								</Formik>
							</Section>
						</Col>
						<Col lg={10}></Col>
					</HeroImage> */}

					<IntroBlock />
				</Col>
			</Row>

			<Section className="pos-rel pt4em">
				<Donut src={orangeEl} alt="Orange donut" width="45%" bottom="-150px" right="-200px" />
				<Donut src={purpleEl} alt="Purple donut" left="-200px" />
				<MainRow gutter={!mobile && 32} marginbottom={mobile ? '1em' : '6em'}>
					<Col lg={12} xs={24} order={mobile ? 2 : 0}>
						<VisibilitySensor>
							{({ isVisible }) => (
								<ReactPlayer
									forcevideo={0}
									url={SERVER_BASE_URL + bumperAtHome}
									playsinline
									controls
									muted
									playing={isVisible}
									config={{
										file: {
											attributes: {
												preload: isVisible ? 'metadata' : 'none'
											}
										}
									}}
									width="100%"
								/>
							)}
						</VisibilitySensor>
					</Col>
					<Col lg={12} order={mobile ? 1 : null}>
						<BoldHeadPar
							content={
								<Paragraph>
									<Trans>
										Find <span className="primary">the best tutors</span>
									</Trans>
								</Paragraph>
							}
							subheader={<Trans>See the tutors that match your criteria, and book an assignment</Trans>}
						/>
					</Col>
				</MainRow>
				<Content slug="section-e-1-homepage" />
				{stories.length > 0 && (
					<MainRow>
						<Col lg={24} xs={24}>
							<Heading
								content={
									<span>
										<span className="primary">Tutors stories </span>
										<Trans> in different subject</Trans>
									</span>
								}
							/>
						</Col>
						<Stories stories={stories} history={history} storySeenFun={storySeen} />
					</MainRow>
				)}

				<MainRow /* pl="0" pr="0" */ marginbottom="3em">
					<Col lg={24} xs={24}>
						<Heading
							content={
								<span>
									<Trans>Featured tutors</Trans>
								</span>
							}
						/>
						{tutors.length === 0 && <Empty description={<Trans>No featured tutors yet</Trans>} />}
						{tutors.length > 0 && mobile ? (
							<HorizontalRow height="300px" snapping>
								{tutors.map(person => (
									<Col xs={10} key={person.pvid}>
										<TutorCard data={person} height="160px" onClick={handleClickTutor} />
									</Col>
								))}
							</HorizontalRow>
						) : (
							<TutorCarousel>
								{tutors.map(person => (
									<TutorCard key={person.pvid} data={person} onClick={handleClickTutor} />
								))}
							</TutorCarousel>
						)}
					</Col>
				</MainRow>
				{content.length !== 0 ?
					<MainRow /* pl="0" pr="0" */ marginbottom="3em">
						<Col lg={24} xs={24} >
							<Heading
								content={
									<span>
										<Trans>Featured Content</Trans>
									</span>
								}
							/>
							{content.length === 0 && <Empty description={<Trans>No featured content yet</Trans>} />}
							{content.length > 0 && mobile ? (
								<HorizontalRow height="300px" snapping>
									{content.map(res => (
										<Col xs={16} key={res.pvid}>
											<ContentCard data={res} height="160px" onClick={handleClickContent} />
										</Col>
									))}
								</HorizontalRow>
							) : (
								<TutorCarousel>
									{content.map(res => (
										<ContentCard key={res.pvid} data={res} onClick={handleClickContent} />
									))}
								</TutorCarousel>
							)}
						</Col>
					</MainRow> : ''}
				{articles.length !== 0 ?
					<MainRow /* pl="0" pr="0" */ marginbottom="3em">
						<Col lg={24} xs={24}>
							<Heading
								content={
									<span>
										<Trans>Featured Articles</Trans>
									</span>
								}
							/>
							{articles.length === 0 && <Empty description={<Trans>No featured article yet</Trans>} />}
							{articles.length > 0 && mobile ? (
								<HorizontalRow height="300px" snapping>
									{articles.map(res => (
										<Col xs={10} key={res.pvid}>
											<ArticleCard data={res} height="160px" onClick={handleClickArticle} />
										</Col>
									))}
								</HorizontalRow>
							) : (
								<TutorCarousel>
									{articles.map(res => (
										<ArticleCard key={res.pvid} data={res} onClick={handleClickArticle} />
									))}
								</TutorCarousel>
							)}
						</Col>
					</MainRow> : ''}
				<Content slug="2-tutorcoachcounsellor-page" />
				<MainRow marginbottom="5em">
					<Col lg={24} xs={24}>
						<Heading
							content={
								<span>
									<Trans>Get to know our tutors from</Trans> <span className="primary">{currentCountry.name}</span>
								</span>
							}
						/>
						{introVideoHome.length === 0 && <Empty description={<Trans>No introduction videos yet</Trans>} />}
						{introVideoHome.length > 0 && (
							<HorizontalRow height="260px">
								{introVideoHome.map(item => {
									const url = SERVER_BASE_URL + item.videoIntroductionList.path;
									return (
										<Col lg={5} xs={10} key={item.userPvid}>
											<VisibilitySensor>
												{({ isVisible }) => (
													<ReactPlayer
														config={{
															file: {
																forcevideo: '1',
																attributes: {
																	preload: 'metadata'
																}
															}
														}}
														url={url}
														controls
														width="100%"
														height={mobile ? 160 : '100%'}
														onPlay={() => setSelectedIntroVideo(item)}
													/>
												)}
											</VisibilitySensor>
										</Col>
									);
								})}
							</HorizontalRow>
						)}
					</Col>
				</MainRow>

				<MainRow gutter={48} datalength={subjectOptions.length}>
					<Col lg={12} xs={24}>
						<BoldHeading content={<Trans>Find subjects that are suitable the most to you</Trans>} />
						<Section centered className="px0">
							<img loading="lazy" src={SERVER_BASE_URL + booksAtHome} width="80%" />
						</Section>
					</Col>
					<Col lg={12} xs={24} className="overflowing-section">
						<Row gutter={32}>
							{subjectOptions.map(item => (
								<SubjectColumn key={item.value}>
									<Button block size="large" key={item.value} icon={item.icon} onClick={() => handleSearchBySubject(item)}>
										{item.label}
									</Button>
								</SubjectColumn>
							))}
						</Row>
					</Col>
				</MainRow>

				{consultants.length > 0 && (
					<>
						<MainRow marginbottom={mobile ? '0' : '0'}>
							<Col lg={24} xs={24}>
								<Heading
									level={4}
									content={<Trans>Not sure where/how to begin?</Trans>}
									subheader={<Trans>We have expert consultants in your area ready to help you</Trans>}
								/>
							</Col>
						</MainRow>
						<MainRow justify="start">
							<Col lg={16} xs={24}>
								<Row gutter={16} type="flex">
									{consultants.map(person => (
										<Col lg={8} xs={12} key={person.whatsapp} className="mb2em">
											<Row>
												<Col lg={6}>
													<DynamicIcon type={person.gender === GENDER.male ? 'icon-male' : 'icon-female'} size={30} />
												</Col>
												<Col lg={18}>
													<Heading
														reverse="0"
														content={<Trans>{person.name}</Trans>}
														subheader={
															<Typography>
																<a
																	href={`https://wa.me/${person.whatsapp}?text=${i18n._(
																		t`Hi ${person.name}! I'd like to ask you something regarding the Cudy Marketplace`
																	)}`}
																	target="_blank"
																	rel="noopener noreferrer">
																	+{person.whatsapp}
																</a>
																{person.city ? (
																	<Paragraph>{`${person.city}, ${person.country}`}</Paragraph>
																) : (
																	<Paragraph>{person.country}</Paragraph>
																)}
															</Typography>
														}
													/>
												</Col>
											</Row>
										</Col>
									))}
								</Row>
							</Col>
							<Col lg={4} xs={24}>
								{/* <GifPlayer src="https://assets3.lottiefiles.com/temp/lf20_zsIYUf.json" width={250} height={mobile && 200} /> */}
								<img src="lazyloadimgs/homepage-1.svg" loading="lazy" alt=""></img>
							</Col>
						</MainRow>
					</>
				)}
			</Section>
		</Layout>
	);
}

// prettier-ignore
export default withI18n()(withRouter(withApollo(Home)))

/*
███████╗████████╗██╗   ██╗██╗     ███████╗███████╗
██╔════╝╚══██╔══╝╚██╗ ██╔╝██║     ██╔════╝██╔════╝
███████╗   ██║    ╚████╔╝ ██║     █████╗  ███████╗
╚════██║   ██║     ╚██╔╝  ██║     ██╔══╝  ╚════██║
███████║   ██║      ██║   ███████╗███████╗███████║
╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚══════╝╚══════╝
*/

const HeroImage = styled(Row).attrs(() => ({
	type: 'flex',
	justify: 'center',
	align: 'middle'
}))`
	height: 500px;
	margin-bottom: 4em;
	background: ${`url(${homepageHero}) no-repeat`};
	background-size: cover;
	h2.ant-typography {
		color: #fff;
		line-height: 1;
		font-weight: bold;
		margin-bottom: 0.8em;
	}
`;

const SubjectColumn = styled(Col).attrs(() => ({
	lg: 12,
	xs: 12
}))`
	margin-bottom: 1.5em;
	.ant-btn {
		height: 60px;
		border: none;
		box-shadow: ${baseStyles.boxShadow.mild};
		> span {
			text-overflow: ellipsis;
			overflow-x: hidden;
			max-width: 150px;
		}
		&:hover {
			transform: translateY(-3px);
			box-shadow: ${baseStyles.boxShadow.hover};
		}
	}
	${media.mobile`
        .ant-btn {
            > span {
                max-width: 120px;
            }
        }
    `}
`;

const TutorCarousel = styled(Carousel).attrs({
	addArrowClickHandler: true,
	slidesPerPage: 6,
	slidesPerScroll: 6,
	breakpoints: { 414: { slidesPerPage: 2, slidesPerScroll: 2 } },
	arrowLeft: <LeftOutlined />,
	arrowRight: <RightOutlined />
})`
	.BrainhubCarousel__trackContainer {
		.BrainhubCarousel__track {
			padding: 2em 1em;
		}
	}

	${media.mobile`
		overflow: visible;
		.BrainhubCarousel__customArrows.BrainhubCarousel__custom-arrowRight {
			position: relative;
			right: -10px;
		}
		.BrainhubCarousel__customArrows.BrainhubCarousel__custom-arrowLeft {
			position: relative;
			left: -10px;
		}
	`}
`;

const BoldHeading = styled(Heading)`
	&& {
		margin-bottom: 2em;
		h2 {
			font-weight: bold;
			line-height: 1.2;
		}
	}
`;

const BoldHeadPar = styled(BoldHeading)`
	&& {
		h2 {
			p {
				margin-bottom: 0;
			}
			.primary {
				color: ${baseStyles.primaryColor};
			}
		}
		.ant-typography:not(h2) {
			font-size: 1.4em;
		}
	}
`;

const MainRow = styled(Row).attrs(() => ({
	type: 'flex',
	justify: 'center',
	align: 'middle'
}))`
	padding-left: ${({ pl }) => pl || '8rem'};
	padding-right: ${({ pr }) => pr || '8rem'};
	margin-bottom: ${({ marginbottom }) => marginbottom || '4em'};

	.overflowing-section {
		max-height: ${({ datalength }) => datalength > 16 && '450px'};
		overflow-y: ${({ datalength }) => datalength > 16 && 'scroll'};
		-webkit-overflow-scrolling: touch;
		&::-webkit-scrollbar-thumb {
			border-radius: 8px;
			border: 2px solid ${baseStyles.lightGrey.two};
			background-color: rgba(0, 0, 0, 0.5);
		}
		&::-webkit-scrollbar {
			-webkit-appearance: none;
		}
		&::-webkit-scrollbar:vertical {
			width: 11px;
		}
		&::-webkit-scrollbar:horizontal {
			height: 11px;
		}
	}

	${media.mobile`
        padding-left: 1em;
        padding-right: 1em;
        > .ant-col:first-child {
            margin-bottom: 3em;
        }
    `}
`;

const Donut = styled.img.attrs(({ src, alt, width }) => ({
	src,
	alt,
	width: width || '40%'
}))`
	position: absolute;
	top: ${({ top }) => top && top};
	bottom: ${({ bottom }) => bottom && bottom};
	left: ${({ left }) => left && left};
	right: ${({ right }) => right && right};
	${media.mobile`
        display: none;
    `}
`;
